import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'crmTask';

const crmTaskService = {
  getTaskById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/task/${encodeURIComponent(id)}`,
    });
  },

  getTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tasks`,
      data,
    });
  },

  createTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  updateTask: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      formData: true,
      data,
    });
  },

  deleteTask: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  uploadFile: (file, id, userId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },

  getContactMaps: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/contactMaps`,
      data,
    });
  },

  getParent: (parentId) => {
    return request({
      resource: `${baseURL}/parent/${encodeURIComponent(parentId)}`,
    });
  },
};

export default crmTaskService;
